<template lang="html">
	  <div class="signature-creation">
        <div :class="{'alert alert-success': status == 'success', 'alert alert-danger': status == 'danger'}" role="alert">
              {{ messageText }}
        </div>

        <h4>Start a new signature request</h4>

        <p v-if="quota && quota">There are <strong v-html="quota"></strong> API requests left on our plan. This will reset on the <strong>26th</strong> of the month.</p>
        <p v-if="quota && quota == 0">Please contact the development team should this limit need adjusting.</p>

        <div :class="{ deactive: (request || (quota && quota == 0)) }">
            <form>
                <p>Please select your recipient(s)</p>

                <select ref="select" class="form-control" v-if="article && article.authors && article.authors.length" v-on:change="addSignator">
                    <option value="">Please select your recipients</option>

                    <option v-for="(author, authorIndex) in getAuthorsFiltered()" v-bind:value="authorIndex">
                        {{ author.first_name }} {{ author.last_name }}
                    </option>
                </select>

                <p style="margin-top: 5px;">or <a href="javascript:;" @click="addAllSignators()">Select all</a></p>

                <hr>

                <div v-if="signators && signators.length != 0">
                    <p>Authors Selected</p>

                    <li style="list-style: none;" v-for="(signator, signatorIndex) in signators">
                        {{ signator.email }} | <a href="javascript:;" @click="removeSignator(signatorIndex)">Remove</a>
                    </li>

                    <hr>
                </div>

              <div class="override-ltp-container">
                <input type="checkbox" class="override-ltp-input" name="overrideLtp" v-model="overrideLtp">
                <label for="overrideLtp" class="override-ltp-label">
                  Override already existing LTP request
                </label>
              </div>

                <p>The default template for License to Publish signature requests is located <a href="https://jmir-assets.s3.ca-central-1.amazonaws.com/general/LicenseToPublish.docx">here</a>.</p>
                <p>If you wish to upload a custom document, please see the documentation <a href="https://support.jmir.org/hc/en-us/articles/360042673872">here</a> before doing so.</p>
                <p>Please note, if you do not wish to upload a custom document, the standard license form will be sent to all authors.</p>

                <input @change="setFile" type="file" />
            </form>

            <button :disabled="isSubmitLoading" @click.preventDefault="createNew()" class="signature-creation-submit">
              <span v-if="isSubmitLoading">
                <i class="fa fa-spinner fa-spin"></i>License To Publish Form is generating…
              </span>
              <span v-else>
                Submit
              </span>
            </button>

            <br/>
        </div>
	</div>
</template>

<script>
export default {
  props: ["article_id", "environment"],
  data: {
    article: {},
    quota: null,
    signators: [],
    selected: 0,
    file: null,
    messageText: null,
    status: null,
    isSubmitLoading: false,
    overrideLtp: false,
  },
  methods: {
    getAuthorsFiltered: function () {
      let self = this;

      let filteredSignators = self.signators.map((signator) => {
        return signator.email;
      });

      let filteredAuthors = self.article.authors.filter((author) => {
        return (
          author.email &&
          filteredSignators.indexOf(author.email) === -1);
      });

      return filteredAuthors;
    },
    getQuota: function () {
      let self = this;

      axios.get("/api/signatures").then(function (response) {
        self.quota = response.data.quota;
      });

      this.$forceUpdate();
    },
    getArticle: function () {
      let self = this;

      axios.get("/api/articles/" + self.article_id).then(function (response) {
        self.article = response.data;
        self.signators = [];
        self.$forceUpdate();
      });
    },
    removeSignator: function (index) {
      this.signators.splice(index, 1);

      this.$forceUpdate();
    },
    addSignator: function (evt) {
      let author = this.getAuthorsFiltered()[evt.target.value];
      this.signators.push({
        name: `${author.first_name} ${author.last_name}`,
        primary_contact: author.primary_contact,
        email: author.email,
        orcid: author.orcid,
      });

      this.$refs.select.selectedIndex = 0;

      this.$forceUpdate();
    },
    setFile: function (evt) {
      this.file = evt.target.files[0];
    },
    addAllSignators: function () {
      this.signators = [];

      for (let author of this.article.authors) {
        this.signators.push({
          name: `${author.first_name} ${author.last_name}`,
          primary_contact: author.primary_contact,
          email: author.email,
          orcid: author.orcid,
        });
      }

      this.$forceUpdate();
    },
    createNew: function () {
      this.isSubmitLoading = true;
      this.$forceUpdate();

        // Prevent empty requests
        if (this.signators.length < 1) {
            this.updateAlert(
                "You must include at least one signator in your request",
                "danger"
            );
            this.isSubmitLoading = false;
            this.$forceUpdate();
            return;
        }
        // TODO: Currently API endpoint does not work at all with custom file. In case that part should be fixed it requires additional investigation and requirements.
        // Create the form to send with author information
        let form = new FormData();
        const signatories = this.signators.map((signator) => {
            return {
                email: signator.email,
                name: signator.name,
                orcid: signator.orcid,
            };
        });

        // INFO: Old non used flow.
        form.append("file", this.file);
        form.append("signatories", JSON.stringify(signatories));

        let url = `/v1/signatures/${this.article.article_id}/async`;

         // Call to the API to prepare a documnet with the specified signatories
        axios({
            method: "post",
            url: url,
            data: this.file ? form : {
              signatories: signatories,
              overrideExistingLtp: !!this.overrideLtp,
            },
            headers: this.file
            ? { "Content-Type": "multipart/form-data" }
            : { "Content-Type": "application/json" },
        })
            .then((response) => {
                this.updateAlert("LTP request was queued.", "success");

                this.getQuota();
                this.isSubmitLoading = false;
                this.$forceUpdate();
            })
            .catch((err) => {
                const message = err?.response?.data?.message || 'An error occurred while creating the LTP request';
                this.updateAlert(`New signature failed to send: ${message}`, "danger");

                this.getQuota();
                this.isSubmitLoading = false;
                this.$forceUpdate();
            });
    },
    updateAlert: function (text, status) {
      this.status = status;
      this.messageText = text;
    },
  },
  created() {
    this.getQuota();
    this.getArticle();
  },
  updated() {
    updateIFrameHeight();
  },
};
</script>

<style scoped>
.signature-creation {
  position: relative;
}
.signature-loader {
  position: absolute;
  top: 50%;
  left: 50%;
}

.signature-creation-submit {
  display: block;
  margin-top: 10px;
}

/* Loading animations */
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  opacity: 1;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 40px;
  height: 40px;
  margin: 8px;
  border: 4px solid #000;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}

.override-ltp-container {
  margin: 15px 0;
}

.override-ltp-input {
  opacity: 100%;
  position: relative;
}

.override-ltp-label {
  margin-left: 5px;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
